import { render, staticRenderFns } from "./editOrAdd.vue?vue&type=template&id=5959a3b1"
import script from "./editOrAdd.vue?vue&type=script&lang=js"
export * from "./editOrAdd.vue?vue&type=script&lang=js"
import style0 from "./editOrAdd.vue?vue&type=style&index=0&id=5959a3b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports